import { mapGetters } from "vuex";

export default {
    name: "CosmoBaseHero",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/content"
      })
    },
    methods: {}
}
